import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import React from "react";
import { Controller } from "react-hook-form";

const RadioController = ({
  name,
  label,
  options,
  required,
  control,
  errors,
  disabled = false,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControl component="fieldset" error={!!errors[name]}>
          <FormLabel component="legend" required={required} sx={{ mb: 0 }}>
            {label}
          </FormLabel>
          <RadioGroup
            {...field}
            value={field.value || ""}
            row
            onChange={(e) => field.onChange(e.target.value)}
            disabled={disabled}
          >
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio color="primary" />}
                label={option.label}
                disabled={disabled}
              />
            ))}
          </RadioGroup>
          {errors[name] && (
            <FormHelperText>{errors[name].message}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
};

export default RadioController;
